import React, { useEffect, useState, useCallback } from "react";
import Line from "../../main/Line";
import BackButton from "../../main/BackButton";
import axios from "../../../axios-backend";
import Button from "../../main/Button";
import { Link, useLocation } from "react-router-dom";

const ViewSteps = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const [steps, setSteps] = useState([]);

  const getData = useCallback(() => {
    axios
      .get("/all-steps", {
        params: { sizeFinderId: id },
      })
      .then((data) => {
        setSteps(data.data.data);
      });
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const mapAndRenderSteps = () => {
    return steps.map((item, index) => {
      return (
        <Line type="bottom-line" key={index}>
          Step: {item.index} &nbsp;&nbsp; Short Name: {item.shortName}
          <Link style={{ marginLeft: "2rem" }} to={`/edit-step?id=${item.id}`}>
            <Button>Edit</Button>
          </Link>
          <Link
            style={{ marginLeft: "2rem" }}
            to={`/view-options?id=${item.id}`}
          >
            <Button>View Options</Button>
          </Link>
        </Line>
      );
    });
  };

  return (
    <>
      <BackButton />
      <Line type="bottom-line">
        <Link to={`/edit-step?sid=${id}`}>
          <Button> Add New Step </Button>
        </Link>
      </Line>
      {steps == null ? null : mapAndRenderSteps()}
    </>
  );
};

export default ViewSteps;
